import {
    useEffect,
    useState
} from 'react';
import {
    Container,
    Content,
    Info,
    Actions,
    AvatarArea,
    Button,
    Note,
    Load
} from './styled';
import {
    Avatar,
    InputList
} from '../../../components';
import { useChat } from '../../../contexts/chat';
import {
    transferCustomer,
    getMotivation,
    transferCustomerServiceLote
} from '../../../service/serviceChat/customerService';
import { toast } from 'react-toastify';


export function Option(props) {

    const {
        onDisable,
        user,
        customer,
        close,
        customersIDs
    } = props;

    const { resetChat, reload } = useChat();

    const [loading, setLoading] = useState(false);
    const [allowNote, setAllowNote] = useState(false);
    const [optionsMotivation, setOptionsMotivation] = useState([]);
    const [selectMotivation, setSelectMotivation] = useState({});
    const [note, setNote] = useState('');

    useEffect(() => {
        if (!allowNote) return
        async function motivationTransfer() {
            const data = await getMotivation()
            setOptionsMotivation(data)
        }
        motivationTransfer()
    }, [allowNote])

    useEffect(() => {
        for (let i in optionsMotivation) {
            if (optionsMotivation[i].tag === "PADRAO") return setSelectMotivation(optionsMotivation[i])
        }
    }, [optionsMotivation])


    async function handTransfer() {
        setAllowNote(false);
        onDisable();
        setLoading(true);
        if ((!customer) && customersIDs.length > 0) {
            const { status, message } = await transferCustomerServiceLote(
                user?.id,
                customersIDs,
                note,
                selectMotivation?.id
            )
            const typeAlert = (status === 200) ? 'success' : 'error'
            toast[typeAlert](
                `${(message)
                    ? message
                    : (`Erro ao Transferir Atendimentos`)
                }`,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
        } else {
            const success = await transferCustomer(
                customer,
                note,
                user?.id,
                selectMotivation?.id,
                false
            );
            const typeAlert = (success) ? 'success' : 'error'
            const message = (success)
                ? 'Atendimento Transferido com Sucesso'
                : 'Erro ao Transferir Atendimento'
            toast[typeAlert](
                `${(message)}`,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            // verificar se está apagando o chat
            // reload();
            resetChat();
        }
        setLoading(false);
        close();
    }

    return (
        <Container
            isStatus={
                (user.tipo) === 'U' ? 1 : 0
            }
            isOnline={
                (user.status) === 'ONLINE' ? 1 : 0
            }
        >
            <Content>
                <Info>
                    <AvatarArea>
                        <Avatar
                            name={user?.nomecompleto}
                            width={'100%'}
                            height={'100%'}
                            fontSize={'1.5rem'}
                        />
                    </AvatarArea>
                    <div className='description--'>
                        <div className={`line-- ${user.tipo === 'U' && 'isStatus'}`}>
                            <p className='name'>{user.nomecompleto}</p>
                        </div>
                        {user.tipo === 'U' &&
                            <div className='line--'>
                                <p>{user.status === 'ONLINE'
                                    ? <>
                                        <span className='circle--on' />
                                        {`Online`}
                                    </>
                                    : <>
                                        <span className='circle--off' />
                                        {`Offline`}
                                    </>
                                }</p>
                            </div>
                        }
                    </div>
                </Info>
                <Actions>
                    <Button onClick={() => setAllowNote(true)}>
                        {!loading
                            ? <>{`Transferir`}</>
                            : <Load />
                        }
                    </Button>
                    {allowNote &&
                        <Note>
                            <label>{`Adicionar Anotação`}</label>
                            <div className='text-area'>
                                <textarea
                                    rows="4"
                                    cols="50"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                />
                            </div>
                            <label>Motivo :</label>
                            <div className='list'>
                                <InputList
                                    options={optionsMotivation}
                                    value={selectMotivation?.name}
                                    onChange={(e) => setSelectMotivation(e)}
                                    toView={'name'}
                                    isSearch={false}
                                />
                            </div>
                            <div className='action'>
                                <Button
                                    onClick={
                                        () => handTransfer()
                                    }
                                >
                                    {`Continuar`}
                                </Button>
                            </div>
                        </Note>
                    }
                </Actions>
            </Content>
        </Container>
    );


}